// --------------------- Import React ---------------------
import { NumberParam, useQueryParams } from "use-query-params";

// --------------------- Import Antd Design ---------------------
import {
  Avatar,
  Button,
  Col,
  Flex,
  Modal,
  Row,
  Skeleton,
  Table,
  Tooltip,
  Typography,
  Upload,
  UploadProps,
} from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";

// --------------------- Import Hooks ---------------------
import { useArquivos } from "./hooks/useArquivos";
import { useMessage } from "../../uteis/mensagens/useMessage";

// --------------------- Import Styles ---------------------
import { Container, ContainerLista } from "./styles";
import { UploadOutlined } from "@ant-design/icons";
import { useFileUpload } from "../ViewGerenciarPropriedadeUsuario/hooks/useUploadFiles";

// --------------------- Import Components ---------------------
import { Columns } from "./components/Columns";
import { useEffect, useState } from "react";
import { useBaixarArquivo } from "./hooks/useBaixarArquivo";
import { useAutenticar } from "./hooks/useAutenticar";
import { useExcluirArquivo } from "./hooks/useExcluirArquivo";
import { useAtualizarArquivo } from "./hooks/useAtualizarArquivo";
import { useMediaQuery } from "react-responsive";

import WORD from "../../images/WORD.png";
import VIDEO from "../../images/video.png";
import EXCEL from "../../images/excel.png";
import PDF from "../../images/pdf.png";
import JPEG from "../../images/jpg.png";
import PNG from "../../images/png.png";
import INDEFINIDO from "../../images/arquivo.png";
import ModalInfo from "./components/ModalInfo";
import ModalAcoes from "./components/ModalAcoes";
import { usePermissaoCotaUsuario } from "../../uteis/permissaoAdm/usePermissaoCotaUsuario";
import { show } from "antd-mobile/es/components/dialog/show";


export default function ViewGerenciarDocumentosProprietarios() {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [fileName, setFileName] = useState<string>("");
  const [mimeType, setMimeType] = useState<string>("");
  const [nomeArquivo, setNomeArquivo] = useState<string>("");
  const [arquivoId, setArquivoId] = useState<number>();
  const [arquivoCotaUsuarioId, setArquivoCotaUsuarioId] = useState<number>();
  const [podeExcluir, setPodeExcluir] = useState<number>();

  const [openMaisArquivo, setOpenMaisArquivo] = useState(false);

  const { Title } = Typography;

  // Recupera os valores enviado pela URL
  const [queryParams] = useQueryParams({
    cotaUsuarioId: NumberParam,
  });
  const cotaUsuarioId = queryParams.cotaUsuarioId;

      // 🔒 Verificação de permissão da cotaUsuario
    const { isLoading: verificando, isValid } = usePermissaoCotaUsuario(Number(cotaUsuarioId));




  const { fetch, arquivos, isLoading } = useArquivos(cotaUsuarioId);

  const { baixarArquivo, isLoading: isLoadingBaixar } = useBaixarArquivo(
    fileName,
    mimeType,
    nomeArquivo
  );

  const {
    autenticar,
    success,
    error,
    isLoading: isLoadingAutenticar,
    resetError: resetErrorAutenticar,
    resetSuccess: resetSuccessAutenticar,
  } = useAutenticar();

  const {
    excluirArquivo,
    success: successExcluir,
    error: errorExcluir,
    resetSuccess: resetSuccessExcluir,
    resetError: resetErrorExcluir,
    isLoading: isLoadingExcluir,
  } = useExcluirArquivo();

  const {
    atualizarArquivo,
    success: successAtualizar,
    error: errorAtualizar,
    resetError: resetErrorAtualizar,
    resetSuccess: resetSuccessAtualizar,
    isLoading: isLoadingAtualizar,
  } = useAtualizarArquivo();

  const { showSuccess, showError, contextHolder } = useMessage();
 

  // Usando o hook
  const {
    fileList,
    uploading,
    handleRemove,
    beforeUpload,
    handleUpload,
    error: arquivoError,
    success: arquivoSuccess,
    resetError,
    resetSuccess,
  } = useFileUpload(cotaUsuarioId);

  const props: UploadProps = {
    onRemove: handleRemove,
    beforeUpload,
    fileList,
  };

  const onClick = async ({
    key,
    arquivoId: arquivoIdRecebido,
    arquivoCotaUsuarioId: arquivoCotaUsuarioIdRecebido,
    podeExcluir: podeExcluirRecebido,
  }: any) => {
    const finalArquivoId = isMobile ? arquivoIdRecebido : arquivoId;
    const finalArquivoCotaUsuarioId = isMobile
      ? arquivoCotaUsuarioIdRecebido
      : arquivoCotaUsuarioId;
    const finalPodeExcluir = isMobile ? podeExcluirRecebido : podeExcluir;

    switch (key) {
      case "1":
        baixarArquivo();
        break;
      case "2":
        autenticar(
          cotaUsuarioId!,
          finalArquivoCotaUsuarioId!,
          finalPodeExcluir!
        );
        break;
      case "3":
        excluirArquivo(finalArquivoId);
        break;
      case "4":
        atualizarArquivo(finalArquivoCotaUsuarioId!, finalPodeExcluir!);
        break;
    }
  };

  const columns = Columns(
    onClick,
    setFileName,
    setMimeType,
    setNomeArquivo,
    setArquivoId,
    setArquivoCotaUsuarioId,
    setPodeExcluir
  );

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState<boolean>(false);
  const [successDisplayed, setSuccessDisplayed] = useState<boolean>(false);

  const [errorAutenticarDisplayed, setErrorAutenticarDisplayed] =
    useState<boolean>(false);
  const [successAutenticarDisplayed, setSuccessAutenticarDisplayed] =
    useState<boolean>(false);

  const [errorExcluirDisplayed, setErrorExcluirDisplayed] =
    useState<boolean>(false);
  const [successExcluirDisplayed, setSuccessExcluirDisplayed] =
    useState<boolean>(false);

  const [errorAtualizarDisplayed, setErrorAtualizarDisplayed] =
    useState<boolean>(false);
  const [successAtualizarDisplayed, setSuccessAtualizarDisplayed] =
    useState<boolean>(false);

useEffect(() => {
  if (verificando) return;

  if (!isValid) {
    alert("Você não tem permissão para acessar estes documentos.");
    setTimeout(() => {
      window.location.href = "/cadastroCotas";
    }, 800);
  }
}, [verificando, isValid]);

    

  useEffect(() => {
    // Exibe a mensagem de sucesso

 
    
  


    if (success && !successAutenticarDisplayed) {
      showSuccess(success);
      setSuccessAutenticarDisplayed(true);
      setOpenMaisArquivo(false);
      setTimeout(() => {
        resetSuccessAutenticar();
        fetch?.();
        setSuccessAutenticarDisplayed(false);
      }, 2000);
    }
    if (arquivoSuccess && !successDisplayed) {
      showSuccess("Arquivo adicionado com sucesso!");
      setSuccessDisplayed(true);
      setOpenMaisArquivo(false);
      setTimeout(() => {
        resetSuccess();
        fetch?.();
        setSuccessDisplayed(false);
      }, 2000);
    }

    if (successExcluir && !successExcluirDisplayed) {
      showSuccess(successExcluir);
      setSuccessExcluirDisplayed(true);
      setOpenMaisArquivo(false);
      setTimeout(() => {
        resetSuccessExcluir();
        fetch?.();
        setSuccessExcluirDisplayed(false);
      }, 2000);
    }

    if (successAtualizar && !successAtualizarDisplayed) {
      showSuccess(successAtualizar);
      setSuccessAtualizarDisplayed(true);
      setOpenMaisArquivo(false);
      setTimeout(() => {
        resetSuccessAtualizar();
        fetch?.();
        setSuccessAtualizarDisplayed(false);
      }, 2000);
    }

    // Exibe a mensagem de erro
    if (error && !errorAutenticarDisplayed) {
      showError(error);
      setErrorAutenticarDisplayed(true);

      setTimeout(() => {
        resetErrorAutenticar();
        setErrorAutenticarDisplayed(false);
      }, 3000);
    }
    if (arquivoError && !errorDisplayed) {
      showError(
        "Não foi possível adicionar arquivo, por favor tente novamente!"
      );
      setErrorDisplayed(true);

      setTimeout(() => {
        resetError();
        setErrorDisplayed(false);
      }, 3000);
    }

    if (errorExcluir && !errorExcluirDisplayed) {
      showError(errorExcluir);
      setErrorExcluirDisplayed(true);

      setTimeout(() => {
        resetErrorExcluir();
        setErrorExcluirDisplayed(false);
      }, 3000);
    }

    if (errorAtualizar && !errorAtualizarDisplayed) {
      showError(errorAtualizar);
      setErrorAtualizarDisplayed(true);

      setTimeout(() => {
        resetErrorAtualizar();
        setErrorAtualizarDisplayed(false);
      }, 3000);
    }
  }, [
    arquivoSuccess,
    arquivoError,
    success,
    error,
    successExcluir,
    errorExcluir,
    successAtualizar,
    errorAtualizar,
    showSuccess,
    showError,
    errorAutenticarDisplayed,
    successAutenticarDisplayed,
    errorExcluirDisplayed,
    successExcluirDisplayed,
    errorAtualizarDisplayed,
    successAtualizarDisplayed,
    errorDisplayed,
    successDisplayed,
    resetError,
    resetSuccess,
    resetErrorAutenticar,
    resetSuccessAutenticar,
    resetErrorExcluir,
    resetSuccessExcluir,
    resetErrorAtualizar,
    resetSuccessAtualizar,
  ]);

  const [modalInfo, setModalInfo] = useState(false);
  const [arquivoSelecionado, setArquivoSelecionado] = useState<any | null>(
    null
  );

  const handleModalInfo = (row: any) => {
    setArquivoSelecionado(row);
    setModalInfo(true);
  };

  const handleFecharModal = () => {
    setModalInfo(false);
  };
  const [selectedData, setSelectedData] = useState<any>({
    arquivoId: null,
    arquivoCotaUsuarioId: null,
    podeExcluir: null,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModalAcoes = (data: any) => {
    setSelectedData(data);
    // Define os dados da linha selecionada
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal excluir assinatura
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  if (verificando) return <Skeleton active />;
if (!isValid) return null;
  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : isMobile ? (
        <Container>
          {contextHolder}

          {/* Cabeçalho */}
          <Row
            align="middle"
            justify="space-between"
            style={{
              marginTop: 10,
              padding: "8px 0",
              borderBottom: "2px solid #eee",
            }}
          >
            <Col style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <Button
                onClick={() => window.history.back()}
                style={{ border: "none", background: "transparent" }}
              >
                <ArrowBackIcon color="primary" />
              </Button>
              <Title
                level={3}
                style={{
                  margin: 0,
                  fontWeight: 500,
                }}
              >
                Documentos
              </Title>
            </Col>

            <Col style={{ marginRight: 10 }}>
              <Button
                onClick={() => setOpenMaisArquivo(true)}
                icon={<UploadOutlined />}
                type="primary"
              >
                Anexar
              </Button>
            </Col>
          </Row>

          {/* Lista de arquivos */}
          <ContainerLista>
            {arquivos.map((row: any, index: number) => (
              <Row
                key={`${row.key}-${index}`}
                style={{
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  maxHeight: "60vh",
                }}
              >
                <Col span={24}>
                  <div
                    style={{
                      width: "100%",
                      borderBottom: "1px solid #ddd",
                      padding: "10px 15px",
                      display: "flex",
                      justifyContent: "space-between", // separa os dois lados
                      alignItems: "center",
                      cursor: "pointer",
                      background: "#fff",
                    }}
                    onClick={() => handleModalInfo(row)}
                  >
                    {/* ESQUERDA: ícone + nome */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        flex: 1, // ocupa o espaço restante
                        minWidth: 0, // necessário para o ellipsis funcionar
                      }}
                    >
                      {/* Ícone tipo arquivo */}
                      {row.tipo === "PDF" ? (
                        <Tooltip title="PDF">
                          <Avatar src={PDF} />
                        </Tooltip>
                      ) : row.tipo === "JPEG" ? (
                        <Tooltip title="JPEG">
                          <Avatar src={JPEG} />
                        </Tooltip>
                      ) : row.tipo === "PNG" ? (
                        <Tooltip title="PNG">
                          <Avatar src={PNG} />
                        </Tooltip>
                      ) : row.tipo === "NEUTRO" ? (
                        <Tooltip title="Indefinido">
                          <Avatar src={INDEFINIDO} />
                        </Tooltip>
                      ) : row.tipo === "WORD" ? (
                        <Tooltip title="WORD">
                          <Avatar src={WORD} />
                        </Tooltip>
                      ) : row.tipo === "MP4" ? (
                        <Tooltip title="VIDEO">
                          <Avatar src={VIDEO} />
                        </Tooltip>
                      ) : row.tipo === "EXCEL" ? (
                        <Tooltip title="EXCEL">
                          <Avatar src={EXCEL} />
                        </Tooltip>
                      ) : null}

                      {/* Nome do arquivo com ellipsis */}
                      <span
                        style={{
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          flex: 1, // ocupa o espaço sobrando no lado esquerdo
                          display: "block",
                        }}
                      >
                        {row.nome}
                      </span>
                    </div>

                    {/* DIREITA: cadeado + botão */}
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      {row.podeExcluir ? (
                        <Tooltip title="Pode excluir">
                          <LockOpenIcon color="primary" />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Não pode excluir">
                          <LockIcon color="primary" />
                        </Tooltip>
                      )}

                      <Button
                        type="primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          showModalAcoes({
                            arquivoId: row.arquivoId,
                            arquivoCotaUsuarioId: row.cotasUsuariosId,
                            podeExcluir: row.podeExcluir,
                          });
                        }}
                        style={{
                          backgroundColor: "#003644",
                          borderColor: "#003644",
                          color: "white",
                          padding: "3px 11px",
                        }}
                      >
                        Ações
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            ))}
          </ContainerLista>

          {/* Modais */}
          <ModalInfo
            isModalOpen={modalInfo}
            handleFechar={handleFecharModal}
            arquivosSelecionado={arquivoSelecionado}
          />
          <ModalAcoes
            isModalOpen={isModalOpen}
            handleFechar={handleFechar}
            onClick={onClick}
            data={selectedData}
          />
          <Modal
            open={openMaisArquivo}
            title="Adicionar arquivos"
            onOk={handleUpload}
            onCancel={() => setOpenMaisArquivo(false)}
            footer={[]}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Upload {...props}>
                <Button icon={<UploadOutlined />}>Buscar arquivo</Button>
              </Upload>
            </div>
            <Flex align="center" justify="end">
              <Button
                type="primary"
                onClick={handleUpload}
                disabled={fileList.length === 0}
                loading={uploading}
                style={{ marginTop: 16 }}
              >
                {uploading ? "Uploading" : "Anexar"}
              </Button>
            </Flex>
          </Modal>
        </Container>
      ) : (
        <Container>
          {contextHolder}
          <Row>
            <Flex align="center" justify="center" style={{ width: "100%" }}>
              <Col span={3}>
                <Flex
                  align="center"
                  justify="center"
                  style={{ marginLeft: 10, marginBottom: 5 }}
                >
                  <Button
                    onClick={() => {
                      window.history.back();
                    }}
                    style={{ border: "none" }}
                  >
                    <ArrowBackIcon color="primary" />
                  </Button>
                </Flex>
              </Col>
              <Col span={15}>
                <Flex
                  align="center"
                  justify="center"
                  style={{ marginLeft: 10, marginBottom: 5 }}
                >
                  <Title level={3}>Documentos do proprietário</Title>
                </Flex>
              </Col>
              <Col span={6}>
                <Button
                  onClick={() => setOpenMaisArquivo(true)}
                  icon={<UploadOutlined />}
                  type="primary"
                  style={{ marginBottom: 16, alignSelf: "left" }}
                >
                  Anexar
                </Button>
              </Col>

              <Modal
                open={openMaisArquivo}
                title="Adicionar arquivos"
                onOk={handleUpload}
                onCancel={() => setOpenMaisArquivo(false)}
                footer={[]}
              >
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Upload {...props}>
                    <Button icon={<UploadOutlined />}>Buscar arquivo</Button>
                  </Upload>
                </div>
                <Flex align="center" justify="end">
                  <Button
                    type="primary"
                    onClick={handleUpload}
                    disabled={fileList.length === 0}
                    loading={uploading}
                    style={{ marginTop: 16 }}
                  >
                    {uploading ? "Uploading" : "Anexar"}
                  </Button>
                </Flex>
              </Modal>
            </Flex>
          </Row>

          <Row>
            <Col span={3}></Col>
            <Col span={18}>
              <Flex
                align="start"
                justify="center"
                style={{ width: "100%", overflow: "auto" }}
              >
                <Table
                  columns={columns}
                  dataSource={arquivos}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                />
              </Flex>
            </Col>
            <Col span={3}></Col>
          </Row>
        </Container>
      )}
    </>
  );
}
